import fetch from '../../fetch';

export async function sendPawaPayDeposit(reservationId, country, currency, phoneNumber, provider) {
  const response = await fetch('/pawapay/deposit', {
    method: 'post',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ reservationId, country, currency, phoneNumber, provider }),
    credentials: 'include'
  });
  return response.json();
}
